import { render, staticRenderFns } from "./examineView.vue?vue&type=template&id=06914f1c&scoped=true"
import script from "./examineView.vue?vue&type=script&lang=js"
export * from "./examineView.vue?vue&type=script&lang=js"
import style0 from "./examineView.vue?vue&type=style&index=0&id=06914f1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06914f1c",
  null
  
)

export default component.exports